<div id="statusMessages" >
  @if (blockOrderAllocData.length > 0) {
    <div>
      <div style="display: block; height: auto;" class="statusMessage warning">
        <div style="max-width: 830px; float: left;">
          <div class="main" style="max-width: 830px; margin: 10px;">
            <div style="font-weight:normal;">One or more block orders have been partially or manually executed or manually allocated.<br/>
              <strong>You must go to the Schwab Advisor Center block allocations page to allocate shares in the block order(s) before 6pm ET.</strong></div>
              <div id="blockAllocMessage" class="allocationNamesBlock multipleNames">
                @for (d of blockOrderAllocData; track d; let i = $index) {
                  <span>{{d.allocationName}}</span>
                }
              </div>
            </div>
          </div>
          <a (click)="dismissBlockOrderAllocAlerts()" class="notification-close"></a>
          <br class="clear"/>
        </div>
      </div>
    }

    <!-- <div *ngFor="let d of filteredData; let i = index">
    <div *ngIf="d.type == 'MMC_INVOICE'" id="{{d.type}}" style="display: block; height: auto;" class="statusMessage warning">
      <div style="max-width: 830px; float: left;">
        <div class="main" style="max-width: 830px; margin: 15px 10px;">A new Model Market Center monthly invoice is available on the iRebal Home page.</div>
      </div>
      <a (click)="dismiss(d.type,i)" class="notification-close"></a>
      <br class="clear"/>
    </div>

    <div *ngIf="d.type == 'MMC_MODEL_STRATEGIST_FEE_UPDATE'" id="{{d.type}}" style="display: block; height: auto;" class="statusMessage warning">
      <div style="max-width: 830px; float: left;">
        <div class="main" style="max-width: 830px; margin: 15px 10px;">{{d.data.count}} Subscribed Model(s) have unread Strategist Fee changes.</div>
      </div>
      <a (click)="dismiss(d.type,i)" class="notification-close"></a>
      <br class="clear"/>
    </div>

    <div *ngIf="d.type == 'MMC_MODEL_ALLOCATION_UPDATE'" id="{{d.type}}" style="display: block; height: auto;" class="statusMessage warning">
      <div style="max-width: 830px; float: left;">
        <div class="main" style="max-width: 830px; margin: 15px 10px;">{{d.data.count}} Subscribed Model(s) have unread Allocation changes.</div>
      </div>
      <a (click)="dismiss(d.type,i)" class="notification-close"></a>
      <br class="clear"/>
    </div>
  </div> -->
</div>
